<template>
    <div :class="{'back-img':background}" :style="background?'background-image:url('+src+');':''" class="pr">
        <slot v-if="!background"></slot>
        <div class="hover-show">
            <span @click="dialogVisible = true" class="el-upload-list__item-preview"><i class="el-icon-zoom-in"></i></span>
        </div>
        <el-dialog :modal-append-to-body="false" :visible.sync="dialogVisible">
            <img width="100%" :src="src" :alt="alt">
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:{
        background:{
            type:Boolean,
            default:true,
        },
        src:{
            type:String,
            default:'',
            required:true,
        },
        alt:{
            type:String,
            default:'图片',
        },
    },
    data(){
        return {
            dialogVisible:false,
        }
    }
}
</script>
<style scoped>
    .pr{
        position: relative;
    }
    .back-img{
        background-size:contain;
        background-position:center;
        background-repeat:no-repeat;
    }
    .hover-show{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        text-align: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0,0,0,.5);
        transition: opacity .3s;
    }
    .pr:hover .hover-show{
        opacity:1;
    }
    .el-upload-list__item-preview{
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }
    .hover-show::before{
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }
</style>